export default "__VITE_ASSET__BLd7sVvY__"